module.exports = __webpack_public_path__ + "img/shipo-menu-unloading-checklist.24d0130b.svg";